export const ROLES = new Map([
  ["admin", "Administrador"],
  ["client", "Usuário principal"],
  ["client_user", "Sub Usuário"],
  ["external_user", "Usuário externo"]
]);

export const USER_DELETION_REASONS = {
  USER_REQUESTED_DELETION: "Cliente pediu para sair da base.",
  DUPLICATE_ACCOUNT: "Cliente está duplicado.",
  REGISTRATION_DATA_ERROR: "Cliente possui erro de cadastro.",
  INTERNAL_ACCOUNT: "Conta interna que precisa ser excluída.",
  OTHER: "Outro:",
};